// NPM Imports
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import STRIPE_LOGO from "../../../assets/logo-stripe.png";

const AddComponentBlocks = ({
  blocks,
  customClassName,
  handleOnClick,
  handleDragStart,
  handleDragEnd,
  isDraggable,
  isClickable,
}) => (
  <div className={`addcomponentblocks-container ${customClassName} `}>
    {blocks.map(block => (
      // -------- Block Button Tooltip Section --------
      <div
        key={block.id}
        className={`addcomponentblocks-block-btn ${
          block.isDisabled ? "is-disabled" : ""
        } ${isClickable ? "clickable-button" : ""}`}
        data-test={`add-component-btn-${block.id}`}
        draggable={isDraggable && !block.isDisabled}
        onDragStart={
          isDraggable && !block.isDisabled && handleDragStart
            ? event => handleDragStart(event, block.id)
            : undefined
        }
        onDragEnd={
          isDraggable && !block.isDisabled && handleDragEnd
            ? handleDragEnd
            : undefined
        }
        onClick={
          isClickable && handleOnClick
            ? event => handleOnClick(event, block.id)
            : () => {}
        }
        onKeyPress={() => {}}
        role="button"
        tabIndex="0">
        {/* -------- Block Button Label Section -------- */}
        {block.isBeta && <span className="new-tag">New</span>}
        {/* -------- Block Button Icon Section -------- */}
        {block.id !== "add-payment-button" ? (
          <FontAwesomeIcon
            icon={block.icon}
            className="addcomponentblocks-blockbtn-icon"
          />
        ) : (
          <img
            className="stripe-logo addcomponentblocks-blockbtn-icon"
            alt="stripe"
            src={STRIPE_LOGO}
          />
        )}

        {/* -------- Block Button Text Section -------- */}
        <span id={block.id}>{block.label}</span>
      </div>
    ))}
  </div>
);

export default AddComponentBlocks;



// WEBPACK FOOTER //
// ./src/components/DocumentComponents/AddComponentBlocks/index.js